
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2021-03-20-recoiljs",
      function () {
        return require("private-next-pages/blogs/2021-03-20-recoiljs/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2021-03-20-recoiljs"])
      });
    }
  